<template>
  <div id="myLogHomeDetail" style="position:relative">
    <div class="head-btn head-btn2 t_r" >
      <span @click="$commonJs.backURL" class="btn-back">
          <span>返回</span>
        </span>
    </div>
    <div>
      <nav class="greenBox">
        {{ formName }}
      </nav>
      <div class="back_colorWidth p_b_10">
        <div style="padding: 20px 20px 0 20px">
          <div class="allDl d_flex">
            <dl class="allDl_width30 allDl_span60" style="width: 80%">
            <dd style="width: 40%">
                <span>时间段:</span>
                <div class="d_flex" style="display: inline-flex">
                    <div style="width: 45%">
                        <cander v-model="postData.StartTime" :className="'allInput'" :newWidth="'100%'"></cander>
                    </div>
                    <div class="t_c" style="width: 40px">至</div>
                    <div style="width: 45%">
                        <cander :minDate="postData.StartTime"  v-model="postData.EndTime" :className="'allInput'" :newWidth="'100%'"></cander>
                    </div>
                </div>
            </dd>
            <dt style="width: auto">
                <button @click="getAllList(1)" class="suerButton"><i class="icon iconfont iconsousuo" style="font-size: 14px"></i><span class="m_l_5">搜索</span></button>
                <button @click="exportLog()" class="suerButton" :disabled="isBtn"><span class="m_l_5">导出</span></button>
            </dt>
            </dl>
          </div>
          <div style="overflow: auto;" :style="{'max-height': tableHeight + 'px'}" class="m_t_20">
            <table v-if="formChildTableId == 1" class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th>用户名</th>
                  <th>用户邮箱地址</th>
                  <th>操作时间</th>
                  <th>操作名称</th>
                  <th>一级菜单</th>
                  <th>二级菜单</th>
                  <th>备注</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myAllList">
                  <td>{{ item.creatorName }}</td>
                  <td>{{ item.creatorEmail }}</td>
                  <td>{{ item.operationTime }}</td>
                  <td>{{ item.operationName }}</td>
                  <td>{{ item.firstLevelMenu }}</td>
                  <td>{{ item.secondLevelMenu }}</td>
                  <td>{{ item.remark }}</td>
                </tr>
              </tbody>
            </table>
            <table v-if="formChildTableId == 2" class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th>邮件接收人邮箱</th>
                  <th>邮件任务开始时间</th>
                  <th>上传表名称</th>
                  <th>邮件调用接口成功</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myAllList">
                  <td>{{ item.remindEmail }}</td>
                  <td>{{ item.createTime }}</td>
                  <td>{{ item.tableName }}</td>
                  <td>{{ item.isSuccess }}</td>
                </tr>
              </tbody>
            </table>
            <table v-if="formChildTableId == 3" class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th>用户名</th>
                  <th>用户邮箱地址</th>
                  <th>邮件任务发送时间</th>
                  <th>操作类型</th>
                  <th>宽表名称</th>
                  <th>下载文件名称</th>
                  <th>邮件调用接口成功</th>
                  <th>收件人邮箱</th>
                  <th>参数</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myAllList">
                  <td>{{ item.actionUser }}</td>
                  <td>{{ item.actionEmail }}</td>
                  <td>{{ item.actionTime }}</td>
                  <td>{{ item.subscribeType }}</td>
                  <td>{{ item.tableName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.emails }}</td>
                  <td>{{ item.paramterJson }}</td>
                </tr>
              </tbody>
            </table>
            <table v-if="formChildTableId == 4" class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th>用户名</th>
                  <th>用户邮箱地址</th>
                  <th>操作时间</th>
                  <th>宽表名称</th>
                  <th>下载文件名称</th>
                  <th>下载入口</th>
                  <th>参数</th>
                  <th>是否下载成功</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myAllList">
                  <td>{{ item.actionUser }}</td>
                  <td>{{ item.actionEmail }}</td>
                  <td>{{ item.actionTime }}</td>
                  <td>{{ item.tableName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.module }}</td>
                  <td>{{ item.paramterJson }}</td>
                  <td>{{ item.status }}</td>
                </tr>
              </tbody>
            </table>
            <table v-if="formChildTableId == 5" class="allTable" cellspacing="0">
              <thead>
                <tr>
                  <th>用户名</th>
                  <th>用户邮箱地址</th>
                  <th>邮箱提醒时间</th>
                  <th>宽表名称</th>
                  <th>下载文件名称</th>
                  <th>邮件调用接口成功</th>
                  <th>参数</th>
                </tr>
              </thead>
              <tbody>
                <tr :key="index" v-for="(item, index) in myAllList">
                  <td>{{ item.actionUser }}</td>
                  <td>{{ item.actionEmail }}</td>
                  <td>{{ item.actionTime }}</td>
                  <td>{{ item.tableName }}</td>
                  <td>{{ item.fileName }}</td>
                  <td>{{ item.status }}</td>
                  <td>{{ item.paramterJson }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <page :totalCount="totalCount" v-if="totalPage !== 0" v-on:on-getList="getAllList($event)" :totalPage="totalPage" :page="page" :numPage="1"></page>
      </div>
    </div>
    <model v-if="showModel" :title="'正在下载'" :minWidth="'60%'" :showClose="1" :onButton="0" v-on:on-cancel="showModel3 = false">
      <div class="pd_10_20">
        <div class="filrProgNum" style="margin: auto">
          <p class="d_flex">
            <span>{{ upName }}</span>
            <span class="colorGray9D9D9D">{{ uploadMdoel }}%</span>
          </p>
          <div class="m_t_5 m_b_5">
            <div :style="{'width': uploadMdoel + '%'}"></div>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
let timeHeight
export default {
  name: 'myLogHomeDetail',
  data () {
    return {
      totalPage: 0,
      totalCount: 0,
      page: 1,
      formChildTableId: parseInt(this.$route.query.formChildTableId),
      formName: this.$route.query.formName,
      postData: {
        StartTime: '',
        EndTime: '',
        pageIndex: 1,
        pageSize:
          window.localStorage.getItem(window.location.hash + 'gyspage') ||
          this.$commonJs.commonPageSize
      },
      myAllList: [],
      isBtn: false,
      showModel: false,
      uploadMdoel: 0,
      tableHeight: 0
    }
  },
  created () {
    this.getAllList(1)
  },
  mounted () {
    timeHeight = setTimeout(p => {
      this.tableHeight = window.innerHeight - 350
    }, 1000)
  },
  destroyed () {
    clearTimeout(timeHeight)
  },
  methods: {
    getAllList (page) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.pageIndex = page
      let url = ''
      switch (this.formChildTableId) {
        case 1: url = this.$commonJs.returnQuery('/api/SystemLog/SearchOperationLog', data); break
        case 2: url = this.$commonJs.returnQuery('/api/SystemLog/SearchUploadRemindLog', data); break
        case 3: url = this.$commonJs.returnQuery('/api/SystemLog/QuerySubscribeSendLog', data); break
        case 4: url = this.$commonJs.returnQuery('/api/SystemLog/QueryDownloadSyncLog', data); break
        case 5: url = this.$commonJs.returnQuery('/api/SystemLog/QueryDownloadAsyncLog', data)
      }
      this.$axiox.get(url).then((msg) => {
        this.myAllList = msg.datas || []
        this.page = page
        this.totalPage = Math.ceil(msg.total / this.postData.pageSize)
        this.totalCount = msg.total
      })
    },
    exportLog () {
      this.isBtn = true
      setTimeout(p => {
        this.isBtn = false
      }, 2000)
      let that = this
      let data = JSON.parse(JSON.stringify(this.postData))
      data.pageIndex = this.page
      let url = ''
      let fileName = ''
      switch (this.formChildTableId) {
        case 1: url = this.$commonJs.returnQuery('/api/SystemLog/ExportOperationLog', data); fileName = '操作日志'; break
        case 2: url = this.$commonJs.returnQuery('/api/SystemLog/ExportUploadRemindEmailLog', data); break
        case 3: url = this.$commonJs.returnQuery('/api/SystemLog/ExportSubscribeSendLog', data); break
        case 4: url = this.$commonJs.returnQuery('/api/SystemLog/ExportDownloadSyncLog', data); fileName = '用户下载文件日志'; break
        case 5: url = this.$commonJs.returnQuery('/api/SystemLog/ExportDownloadAsyncLog', data); fileName = '异步导出提醒邮件日志'
      }
      console.log('url: ' + url)
      that.uploadMdoel = 0
      var xmlResquest = new XMLHttpRequest()
      url = this.$baseUrlConfig.baseUrl + url
      xmlResquest.open('GET', url, true)
      xmlResquest.onprogress = function (e) {
        var percent = e.loaded / e.total
        that.uploadMdoel = parseInt(percent * 100)// progress 在data中定义的全局变量，显示的进度
        // console.log(that.uploadPercent)
        that.upName = fileName ? fileName + '.xlsx' : that.formName + '.xlsx'
        that.showModel = true
      }
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('gskToken'))
      xmlResquest.setRequestHeader('Ocp-Apim-Subscription-Key', this.$baseUrlConfig.ocpKey)
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        var content = xmlResquest.response
        if (content.type) {
          if (content.type.indexOf('json') >= 0) {
            that.$commonJs.alertTips({
              type: 'error',
              title: '失败',
              content: '暂无数据',
              stayTime: 5
            })
            that.showModel = false
            return
          }
        }
        var elink = document.createElement('a')
        elink.download = fileName ? fileName + '.xlsx' : that.formName + '.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        if (that.$IENum === 11) {
          window.navigator.msSaveOrOpenBlob(blob, name + '.xls')
        } else {
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          document.body.removeChild(elink)
        }
        that.showModel = false
      }
      xmlResquest.send()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/mySystemMessager/myLogHomeDetail.vue